// management/recovery/get/:id
import api, { api2 } from "../controllers/api";
import Cookies from "js-cookie";
const BASE_URL = process.env.REACT_APP_SERVER_URL;
const postData = async (url, data, formdata) => {
  try {
    const token = Cookies.get("authToken");
    let header = {};
    if (formdata) {
      header = {
        Authorization: `carrum ${token}`,
        // 'Content-Type': 'multipart/form-data',
      };
    } else {
      header = {
        Authorization: `carrum ${token}`,
        "Content-Type": "application/json",
      };
    }

    const result = await fetch(`${BASE_URL + url}`, {
      method: "POST",
      headers: header,
      body: data,
    });
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};

export const fleetRecoveryWithIDAPI = async (fleetID) => {
  try {
    const url = `/management/recovery/get/${fleetID}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};

export const fleetRecoveryAllAPI = async () => {
  try {
    const url = `/management/recovery/getAllRequest/?limit=${100000}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};
// /management/recovery/imageUpload

export const fleetManagementImageUploadAPI = async (formData) => {
  try {
    const url = `/management/recovery/imageUpload`;
    // const formData = new FormData();
    // formData.append("image", file);
    const result = await postData(url, formData, true);
    const newResult = await result.json();
    // setImagesChanges((prev)=>prev+1);
    return newResult;

    // const url = `/management/recovery/imageUpload`
    // const result = api.post(url,)
  } catch (error) {
    throw error;
  }
};

export const handoverReceiveImageUploadAPI = async (formData) => {
  try {
    const url = `/fleet/imageUpload`;
    // const formData = new FormData();
    // formData.append("image", file);
    const result = await postData(url, formData, true);
    const newResult = await result.json();
    // setImagesChanges((prev)=>prev+1);
    return newResult;

    // const url = `/management/recovery/imageUpload`
    // const result = api.post(url,)
  } catch (error) {
    throw error;
  }
};

export const fleetSingleRecordUpdateID = async (recoveryID, obj) => {
  try {
    const url = `/management/recovery/updateRequest/${recoveryID}`;
    const result = api.put(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const fleetReceiveHandoverListAPI = async (query) => {
  try {
    const url = `/fleet/allRequestForParking?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const fleetReceiveHandoverAllCSV2API = async (query) => {
  try {
    const url = `/fleet/allRequestForParking?${query ? query : ""}`;
    const result = await api2.getData(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const fleetReceiveIDAPI = async (obj) => {
  try {
    const url = `/fleet/request/${obj.id}/${obj.type}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};

export const fleetCarDropReceiveAPI = async (obj) => {
  try {
    const url = `/management/car_drop/request_actions`;
    const result = api.post(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const fleetExchangeReceiveAPI = async (obj) => {
  try {
    const url = `/fleet/vehicleAssign`;
    const result = api.put(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const fleetRecoveryReceiveAPI = async (id, obj) => {
  try {
    const url = `/management/recovery/updateRequest/${id}`;
    const result = api.put(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const updateRecoveryAgentAPI = async (payload) => {
  try {
    const url = `/management/recovery/updateRecoveryAgent`;
    const result = await api2.put(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

//   fleet/vehicleAssignById/:id
export const fleetHandoverWithIDAPI = async (id) => {
  try {
    const url = `/fleet/vehicleAssignById/${id}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};

export const fleetReceiveHistory = async (id) => {
  try {
    const url = `/fleet/history/${id}/receive`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};

export const fleetHandoverHistory = async (id) => {
  try {
    const url = `/fleet/history/${id}/handover`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};

export const fleetAllotmentHistory = async (id) => {
  try {
    const url = `/fleet/getAllotmentHistoryByVehicle/${id}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};

export const fleetRecoveryHistory = async (id) => {
  try {
    const url = `/management/recovery/history/${id}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    console.error(error);
    // throw error;
  }
};

export const fleetHandoverPUTAPI = async (obj) => {
  try {
    const url = `/fleet/vehicleAssign`;
    const result = api.put(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const HandoverReceiveIDApi = async (fleetID) => {
  try {
    const url = `/fleet/gethandoverandrecieveRequest/${fleetID}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

//   /fleet/history/:vehicleId/:type
export const AssignDMToVehicle = async (payload) => {
  try {
    const url = `/fleet/assigndm`;
    const result = api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};
// filtes api for handover and receive
export const getHandoverReceiveFiltersAPI = async (type, field, query) => {
  try {
    const url = `/fleet/handoverReceive/filters/${type}${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getHandoverReceiveListCSVAPI = async (type, query) => {
  try {
    const url = `/fleet/handoverReceive/${type}?type=csv&${query ? query : ""}`;
    const result = await api2.getData(url);
    return result;
  } catch (error) {
    throw error;
  }
};
